import { useEffect, useCallback, useRef } from "react";
import { authService } from "../../services";

const LOGIN_PATH = "/auth/signIn";

export function useSessionGuard() {
  const isValidating = useRef(false);

  const validateSession = useCallback(async () => {
    if (isValidating.current) return;

    if (!authService.isAuthenticated()) {
      authService.clearTokens();
      window.location.replace(LOGIN_PATH);
      return;
    }

    isValidating.current = true;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/users/infos?ipi=false`,
        {
          method: "GET",
          credentials: "include",
          cache: "no-store",
          headers: {
            Authorization: authService.getToken("token") || "",
          },
        }
      );

      if (response.status === 401 || response.status === 403) {
        authService.clearTokens();
        window.location.replace(LOGIN_PATH);
      }
    } catch {
      authService.clearTokens();
      window.location.replace(LOGIN_PATH);
    } finally {
      isValidating.current = false;
    }
  }, []);

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        validateSession();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        if (!authService.isAuthenticated()) {
          authService.clearTokens();
          window.location.replace(LOGIN_PATH);
        }
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [validateSession]);
}
